<script setup>
  import LegalPageLayout from '@/Layouts/LegalPageLayout.vue';
  import LegalOrderedList from '@/Components/LegalOrderedList.vue';
  import LegalSection from '@/Components/LegalSection.vue';
</script>

<template>
  <LegalPageLayout>
    <div class="container mx-auto p-6 pb-12 text-justify">
      <h1 class="text-center text-3xl font-bold">DMCA Policy</h1>
      <p>Last updated: October 1, 2024</p>
      <LegalSection title="Termination of User Account">
        <LegalOrderedList
          :items="[
            'We will terminate a user’s access to the service if, under appropriate circumstances, the user is determined to be a repeat infringer.',
            'We reserve the right to decide whether material or activity violates our Terms of Service for reasons other than copyright infringement. We may remove that material or terminate a user’s account for submitting that material in violation of our Terms of Service.'
          ]"
        />
      </LegalSection>
      <div>
        <LegalSection title="DMCA Notification">
          <p class="mb-4">
            We will respond to allegations of copyright violations in accordance
            with the Digital Millennium Copyright Act (DMCA). The DMCA provides
            a process for a copyright owner to notify an online service provider
            concerning alleged copyright infringement. When an effective DMCA
            notification is received, the online service provider responds by
            taking down the offending content.
          </p>
        </LegalSection>
        <LegalSection title="To File a DMCA Notification">
          <div>
            <p>You can send the DMCA Notice to our Designated Agent at:</p>
            <p>MMT Dev LLC</p>
            <p>Attn: Designated Copyright Agent</p>
            <p>[NAME OF DESIGNATED AGENT]</p>
            <p>[STREET ADDRESS]</p>
            <p>[CITY, STATE ZIP]</p>
            <p>
              <a
                href="mailto:dmca@spicycollab.com"
                class="text-blue-500 hover:text-blue-700"
              >
                dmca@spicycollab.com
              </a>
            </p>
            <p class="mt-4 rounded border-2 border-black p-2">
              Any person who knowingly materially misrepresents that material or
              an activity is infringing or that any material or activity was
              removed or disabled by mistake or misidentification, will be
              liable to us for any damages, including costs and attorneys’ fees
              incurred by us in removing or disabling access to the material or
              activity claimed to be infringing or in replacing the removed
              material or enabling access to it.
            </p>
            <p class="mt-4">
              <span class="font-bold">To File a Counternotification.</span>
              If you believe that your content/material that was removed or to
              which access was disabled is not infringing, or that you have the
              authorization from the copyright owner, the copyright owner’s
              agent, or under the law, to post and use the material, you may
              send a Counternotification containing the following information to
              our Designated Agent:
            </p>
            <LegalOrderedList
              :items="[
                'Your physical or electronic signature;',
                'Identification of the material that has been removed or to which access has been disabled and the location at which the material appeared before it was removed or access disabled;',
                'A statement that you have a good faith belief that the material was removed or disabled as a result of mistake or a misidentification of the material;',
                'Your name, address, telephone number, and email address, a statement that you consent to the jurisdiction of the US district court in the state in which you reside (or the US District Court for the District of Nevada if your address is outside of the United States), and a statement that you will accept service of process from the person who provided notification of the alleged infringement to us.'
              ]"
            />
            <p>
              You can send the Counternotification to our Designated Agent at:
            </p>
            <p>MMT Dev LLC</p>
            <p>Attn: Designated Copyright Agent</p>
            <p>[NAME OF DESIGNATED AGENT]</p>
            <p>[STREET ADDRESS]</p>
            <p>[CITY, STATE ZIP]</p>
            <p>
              <a
                href="mailto:dmca@spicycollab.com"
                class="text-blue-500 hover:text-blue-700"
              >
                dmca@spicycollab.com
              </a>
            </p>
            <p class="mt-4 rounded border-2 border-black p-2">
              Any person who knowingly materially misrepresents that material or
              an activity is infringing or that any material or activity was
              removed or disabled by mistake or misidentification, will be
              liable to us for any damages, including costs and attorneys’ fees
              incurred by us in removing or disabling access to the material or
              activity claimed to be infringing or in replacing the removed
              material or enabling access to it.
            </p>
          </div>
        </LegalSection>
      </div>
    </div>
  </LegalPageLayout>
</template>
